import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import { BrandingProvider } from "./context/BrandingContext";
import Login from "./pages/Login";
import InviteAccept from "./pages/InviteAccept";
import Dashboard from "./pages/Dashboard";
import Inbox from "./pages/Inbox";
import Sites from "./pages/Sites";
import AISettings from "./pages/AISettings";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center animate-pulse">
            <div className="w-4 h-4 bg-white rounded-sm" />
          </div>
          <p className="text-slate-400 text-sm">Yükleniyor...</p>
        </div>
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/inbox" element={<PrivateRoute><Inbox /></PrivateRoute>} />
      <Route path="/sites" element={<PrivateRoute><Sites /></PrivateRoute>} />
      <Route path="/ai" element={<PrivateRoute><AISettings /></PrivateRoute>} />
      <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrandingProvider>
        <AuthProvider>
          <LangProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </LangProvider>
        </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
